export default {"src":"/_next/static/media/watercress.c76114b6.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};